module.exports = __webpack_public_path__ + "img/title-pic.86bb12aa.png";